import axios from 'axios';

type filterValues = string | string[];

type RequestOptions = {
    path: string;
    filters?: {
        [key: string]: filterValues;
    }
};

const buildRequestString = (options: RequestOptions) => {
    const params = new URLSearchParams();

    Object.entries(options).forEach((entry) => {
        if (typeof entry[1] === 'string') {
            params.append(entry[0], entry[1].toString());
        }

        if (typeof entry[1] === 'object') {
            params.append(entry[0], JSON.stringify(entry[1]));
        }
    });
    
    return `/services/v2/contentFragmentServlet${params.toString() ? `.${params.toString().replace('&', '.')}` : ''}`;
};
/**
 * Makes a request to ContentFragmentServlet
 * @example
 * const data = await requestContentFragment({
 *      path: '/content/dam/cob-corp-acquisition/content-fragments/dynamic-card-art',
 *      filters: {
 *          cardImgAltText: 'alt text',
 *      },
 * });
 * @param options - An object with a 'path' and 'filters' field.
 * @returns {Promise<any>}
 */
export const requestContentFragment = async (options: RequestOptions) => {
    if (options.path === null) {
        throw new Error('Path is required when requesting content fragment');
    }

    return axios.get(buildRequestString(options));
};
